var wishlistData = [];
async function myFetchProduct(handle) {
      const options = {
          method: 'GET',
          headers: {
              "Content-Type": "application/json",
              "Accept": "application/json"
          }
      };
      let rout = '/';
      if (Shopify) {
          rout = Shopify?.routes?.root || '/';
      }
      const resp = await fetch(`${rout}products/${handle}.json`, options);
      return resp.json();
}
function myUpdateFloatCounter() {
    const counterNodes = document.querySelectorAll('.kaktus-w-wishlist-counter');
    if (!counterNodes.length) return;
    const localWishlistData = localStorage.getItem('kaktusWishlistData');
    const productsData = localWishlistData ? JSON.parse(localWishlistData) : [];
    counterNodes.forEach(counter => {
        counter.innerHTML = `${productsData.length}`;
    });
}
function myUpdateWishlistData(product) {
                const localWishlistData = localStorage.getItem('kaktusWishlistData');
                const productsData = localWishlistData ? JSON.parse(localWishlistData) : [];
                const updatedProductsData = productsData.filter(item => +item.productId !== +product.id);
                localStorage.setItem('kaktusWishlistData', JSON.stringify(updatedProductsData));
}
function myCreateWishlistData(product) {
    const localWishlistData = localStorage.getItem('kaktusWishlistData');
    wishlistData = localWishlistData ? JSON.parse(localWishlistData) : wishlistData;
    if (wishlistData.length) {
        const checkProductId = wishlistData.find(item => item.productId === product.productId);
        if (!checkProductId) {
            wishlistData.push(product);
        }
    } else {
        wishlistData.push(product);
    }
    localStorage.setItem('kaktusWishlistData', JSON.stringify(wishlistData));
}
function myGetStorePriceByRate(price) {
        const currentCurrencyCode = Shopify.currency.active;
        //let currentCurrencySymbol = kaktusWishlistCurrencySymbol;
        let currencyRate = 1;
        if ('INR' !== currentCurrencyCode) {
           // const country = Shopify.country;
            currencyRate = Shopify.currency.rate;
        }
            return (parseFloat(price) / currencyRate).toFixed(2);
        }
function decodeHTML(html) {
      const txt = document.createElement('textarea');
      txt.innerHTML = html;
      return txt.value;
}
 function myUpdateAddButtonStatus() {
    let localWishlistData = localStorage.getItem('kaktusWishlistData');
    let localProducts = localWishlistData ? JSON.parse(localWishlistData) : [];
    let addBtns = document.querySelectorAll('.kaktus-wishlist-btn');
    if (localProducts.length && addBtns) {
        addBtns.forEach(btn => {
            const btnProductId = btn.getAttribute('data-product-id');
            const isActive = localProducts.find(item => +item.productId === +btnProductId);
            if (isActive) {
                btn.classList.add("kaktus-w-completed");
            } else {
                btn.classList.remove("kaktus-w-completed");
            }
        });
    }
}
function myAddToWishlistEvent(btn,product) {
        
    const getVariantImage = (imageId) => {
        let imgSrc = '';
        const variantImage = product.images.find(img => img.id === imageId);
        if (variantImage) {
            imgSrc = variantImage.src;
        }
        return imgSrc;
    }
    const variantsData = product.variants.map(variant => {
        return {
            productId: variant.id,
            variantPrice: myGetStorePriceByRate(variant.price),
            variantTitle: variant.title,
            image: getVariantImage(variant.image_id)
        }
    })
    const productData = {
        productId: product.id,
        productTitle: product.title,
        description: decodeHTML(product.body_html),
        description_html: product.body_html,
        image: product.image ? product.image.src : noImage,
        variants: variantsData
    }
   
        btn.classList.add('kaktus-w-preload');
        if (btn.classList.contains('kaktus-w-completed')) {
            myUpdateWishlistData(product);
            btn.classList.remove('kaktus-w-completed');
        } else {
            btn.classList.add('kaktus-w-completed');
            myCreateWishlistData(productData);
            let notificationPopup  = document.getElementById("custom-kaktus-w-notification");
            notificationPopup.classList.remove('hide');
            notificationPopup.classList.add('show');
            setTimeout(function(){
               notificationPopup.classList.add('hide');
               notificationPopup.classList.remove('show');  
           }, 2000);
        }
        myUpdateFloatCounter();
        
}
document.addEventListener('DOMContentLoaded', function() {
        myUpdateAddButtonStatus();
        document.querySelectorAll('.kaktus-wishlist-btn').forEach(button => {
            button.addEventListener('click', function() {
              const handle = this.getAttribute('data-product-handle');
                myFetchProduct(handle).then(dataPage => {
                   myAddToWishlistEvent(button,dataPage.product);
                }).catch(error => console.error(error));
            });
        });
  
});
